import React from 'react';
import { Container, Row, Col, Media } from 'reactstrap';
import getConfig from 'next/config';
import { subscribe } from 'react-contextual';


const config = getConfig().publicRuntimeConfig;

const mediaBody = {
	paddingLeft: '1rem',
	fontWeight: '300',
	fontSize: '0.875rem',
};
const mediaImage = {
	marginTop: '0.5rem',
};
const mediaCol = {
	padding: '2rem',
	paddingBottom: 0,
	paddingTop: '3rem',
};
const mediaHeading = {
	fontWeight: '600',
	marginBottom: '0',
};
const GiveFeatures = (props) =>{
   
 return(
	<Container id="give-features">
		<Row style={{ paddingBottom: '0rem' }}>
			<Col lg="4" md="12" sm="12" xs="12" style={mediaCol}>
				<Media>
					<Media left href="#">
						<img src={`${config.cdnUrl}/static/icons/24-7-support.svg`} width="50" height="50" style={mediaImage} />
					</Media>
					<Media body style={mediaBody}>
						<Media heading style={mediaHeading}>
          24/7 Donor Support
						</Media>
						<p>Just a message away for information or assistance to make giving seamless for you.</p>
					</Media>
				</Media>
			</Col>
			<Col lg="4" md="12" sm="12" xs="12" style={mediaCol} >
				<Media>
					<Media left href="#">
						<img src={`${config.cdnUrl}/static/icons/give-assured.svg`} width="50" height="50" style={mediaImage} />
					</Media>
					<Media body style={mediaBody}>
						<Media heading style={mediaHeading}>
							GiveAssured
						</Media>
						<p>A promise to our donors that every listed NGO is legally and financially compliant.&nbsp;
							<span><a className="giveassure-link" href="/giveassured">Learn More</a></span>
						</p>
					</Media>
					<style jsx global>
					{
						`
						.giveassure-link{
							color: ${props.tenantConfig.theme.secondaryColor} !important;
						}
						`
					}
					</style>
				</Media>
			</Col>
			<Col lg="4" md="12" sm="12" xs="12" style={mediaCol}>
				<Media>
					<Media left href="#">
						<img src={`${config.cdnUrl}/static/icons/assured-updates.svg`} width="50" height="50" style={mediaImage} />
					</Media>
					<Media body style={mediaBody}>
						<Media heading style={mediaHeading}>
							100% Guaranteed Updates
						</Media>
						<p>Ensuring you are aware of the impact that your donations are making.</p>
					</Media>
				</Media>
			</Col>
		</Row>
	</Container>
)};

export default subscribe()(GiveFeatures);
